(function () {

  // Free gift product: "free gift" (variant: Default Title)
  const GIFT_VARIANT_ID = 48625404313757;

  function formatMoney(amount) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount * 100);
    }
    return '₹' + Math.ceil(amount).toLocaleString('en-IN');
  }

  const originalFetch = window.fetch;

  let requestToken = 0;
  let debounceTimer = null;
  let giftSyncInProgress = false;

  // ---------------------------------------------------------------
  // "Congratulations" bottom sheet — full-width, dimmed backdrop,
  // confetti burst, floating circular close button on the seam.
  // ---------------------------------------------------------------
  // Both overlay and sheet are appended inside the drawer's own
  // container (not document.body), so they're scoped to the drawer
  // rather than the whole page. We deliberately attach to a stable
  // wrapper (not the node whose innerHTML gets replaced by
  // applySectionUpdate), so they survive a drawer content refresh.
  function findDrawerContainer() {
    return (
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('cart-drawer')
    );
  }

  function ensureGiftOverlay() {
    let overlay = document.getElementById('cgw-overlay');
    const container = findDrawerContainer();
    if (overlay) {
      if (container && overlay.parentElement !== container) {
        container.appendChild(overlay);
      }
    } else {
      overlay = document.createElement('div');
      overlay.id = 'cgw-overlay';
      overlay.className = 'cgw-overlay';
      (container || document.body).appendChild(overlay);
      overlay.addEventListener('click', hideGiftPopup);
    }
    return overlay;
  }

  const POPUP_MARKUP = `
    <button type="button" class="cgw-popup-close" aria-label="Close">&times;</button>
    <div class="cgw-popup-icon">🎁</div>
    <p class="cgw-popup-title">Congratulations!</p>
    <p class="cgw-popup-message">Freebie item has been added to your cart successfully, Enjoy!</p>
  `;

  function ensureGiftPopup() {
    let popup = document.getElementById('cgw-popup');
    const container = findDrawerContainer();
    if (popup) {
      if (container && popup.parentElement !== container) {
        container.appendChild(popup);
      }
      // Self-heal: if a static popup div was hand-added in Liquid
      // (or an older version of this script left a stale one), it
      // may be missing the icon markup. Rebuild the inner content to
      // the canonical structure so styling always works, regardless
      // of what's in the template.
      if (!popup.querySelector('.cgw-popup-icon')) {
        popup.innerHTML = POPUP_MARKUP;
      }
      popup.classList.add('cgw-popup');
      if (!popup.dataset.cgwBound) {
        const closeBtn = popup.querySelector('.cgw-popup-close');
        if (closeBtn) closeBtn.addEventListener('click', hideGiftPopup);
        popup.dataset.cgwBound = 'true';
      }
    } else {
      popup = document.createElement('div');
      popup.id = 'cgw-popup';
      popup.className = 'cgw-popup';
      popup.setAttribute('role', 'status');
      popup.setAttribute('aria-live', 'polite');
      popup.innerHTML = POPUP_MARKUP;
      (container || document.body).appendChild(popup);
      const closeBtn = popup.querySelector('.cgw-popup-close');
      if (closeBtn) closeBtn.addEventListener('click', hideGiftPopup);
      popup.dataset.cgwBound = 'true';
    }
    return popup;
  }

  // Full-drawer confetti layer — separate from the popup's own small
  // confetti burst. This one is sized to the whole drawer container
  // so pieces can rain across the entire visible cart (progress bar,
  // line items, etc.), not just inside the bottom sheet.
  function ensureDrawerConfetti() {
    let holder = document.getElementById('cgw-drawer-confetti');
    const container = findDrawerContainer();
    if (holder) {
      if (container && holder.parentElement !== container) {
        container.appendChild(holder);
      }
    } else {
      holder = document.createElement('div');
      holder.id = 'cgw-drawer-confetti';
      holder.className = 'cgw-drawer-confetti';
      (container || document.body).appendChild(holder);
    }
    return holder;
  }

  // Backup: a capture-phase listener on document, so the close
  // button works even if something else on the page stops the click
  // from bubbling, or the button's own listener somehow never
  // attaches (e.g. theme JS clones/replaces the node later).
  document.addEventListener(
    'click',
    (e) => {
      if (e.target.closest && e.target.closest('.cgw-popup-close')) {
        hideGiftPopup();
      }
    },
    true
  );

  function lockDrawerScroll() {
    const container = findDrawerContainer();
    if (container) container.classList.add('cgw-scroll-lock');
  }

  function unlockDrawerScroll() {
    const container = findDrawerContainer();
    if (container) container.classList.remove('cgw-scroll-lock');
  }

  // Confetti burst — small colored pieces that fall and rotate across
  // the full drawer, then remove themselves once done so they don't
  // pile up in the DOM on repeat opens.
  const CONFETTI_COLORS = ['#f4a340', '#5aa469', '#4a90d9', '#d9587a', '#c98fd1', '#f2c94c'];

  function fireDrawerConfetti() {
    const holder = ensureDrawerConfetti();
    holder.innerHTML = '';
    const pieceCount = 50;
    const fallDistance = Math.max(holder.offsetHeight, 400);
    for (let i = 0; i < pieceCount; i++) {
      const piece = document.createElement('span');
      piece.className = 'cgw-confetti-piece';
      const left = Math.random() * 100;
      const delay = Math.random() * 0.5;
      const duration = 1.8 + Math.random() * 1.4;
      const drift = (Math.random() - 0.5) * 120;
      const rotate = Math.random() * 360 + 180;
      const color = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      piece.style.left = left + '%';
      piece.style.setProperty('--cgw-drift', drift + 'px');
      piece.style.setProperty('--cgw-rotate', rotate + 'deg');
      piece.style.setProperty('--cgw-fall', fallDistance + 'px');
      piece.style.background = color;
      piece.style.animationDelay = delay + 's';
      piece.style.animationDuration = duration + 's';
      holder.appendChild(piece);
    }
    setTimeout(() => {
      holder.innerHTML = '';
    }, 3800);
  }

  let popupAutoHideTimer = null;

  // .drawer__inner specifically — the content wrapper inside the
  // drawer panel. This is what gets the celebratory slide-down bounce
  // when the gift is added.
  function findDrawerInner() {
    return (
      document.querySelector('cart-drawer .drawer__inner') ||
      document.querySelector('.drawer__inner') ||
      findDrawerContainer()
    );
  }

  function celebrateDrawer() {
    const inner = findDrawerInner();
    if (!inner) return;
    // Restart the animation cleanly even if it's still mid-run from a
    // rapid re-trigger, by removing then re-adding on the next frame.
    inner.classList.remove('cgw-drawer-celebrate');
    void inner.offsetWidth; // force reflow
    inner.classList.add('cgw-drawer-celebrate');
    inner.addEventListener(
      'animationend',
      () => inner.classList.remove('cgw-drawer-celebrate'),
      { once: true }
    );
  }

  function showGiftPopup() {
    const popup = ensureGiftPopup();
    const overlay = ensureGiftOverlay();

    // Make sure both start from their hidden state and the browser
    // actually paints that frame before we switch to visible —
    // otherwise, if display/visibility and opacity/transform change
    // in the exact same tick, the browser can skip straight to the
    // end state with no visible transition at all.
    popup.classList.remove('cgw-popup--visible');
    overlay.classList.remove('cgw-overlay--visible');
    void popup.offsetHeight; // force a synchronous reflow

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        popup.classList.add('cgw-popup--visible');
        overlay.classList.add('cgw-overlay--visible');
      });
    });

    lockDrawerScroll();
    fireDrawerConfetti();
    celebrateDrawer();
    clearTimeout(popupAutoHideTimer);
    popupAutoHideTimer = setTimeout(hideGiftPopup, 7000);
  }

  function hideGiftPopup() {
    clearTimeout(popupAutoHideTimer);
    const popup = document.getElementById('cgw-popup');
    const overlay = document.getElementById('cgw-overlay');
    if (popup) popup.classList.remove('cgw-popup--visible');
    if (overlay) overlay.classList.remove('cgw-overlay--visible');
    unlockDrawerScroll();
  }

  // Make sure the popup + overlay elements exist as early as
  // possible, before any cart syncing happens.
  ensureGiftOverlay();
  ensureGiftPopup();
  ensureDrawerConfetti();

  // ---------------------------------------------------------------
  // Goal bar widget logic
  // ---------------------------------------------------------------

  function setMessage(widget, html) {
    const messageEl = widget.querySelector('.cgw-message');
    if (messageEl.innerHTML === html) return;
    messageEl.style.opacity = '0';
    setTimeout(() => {
      messageEl.innerHTML = html;
      messageEl.style.opacity = '1';
    }, 150);
  }

  function findGiftLine(cart) {
    return cart.items.find((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function totalExcludingGift(cart) {
    const giftLine = findGiftLine(cart);
    const giftLineTotal = giftLine ? giftLine.line_price : 0;
    return (cart.total_price - giftLineTotal) / 100;
  }

  // Swaps in freshly-rendered HTML for the cart drawer + icon bubble
  // so the UI reflects backend changes without needing a page refresh.
  // Grabs the widget's current on-screen values so we can re-apply them
  // instantly to a freshly-swapped-in widget node, avoiding a visible
  // flash back to default "Loading…" / 0% state.
  function captureWidgetState() {
    const widget = document.querySelector('.cgw-widget');
    if (!widget) return null;
    const messageEl = widget.querySelector('.cgw-message');
    const fillEl = widget.querySelector('.cgw-progress-fill');
    const shippingStep = widget.querySelector('.cgw-step--shipping');
    const giftStep = widget.querySelector('.cgw-step--gift');
    return {
      messageHtml: messageEl ? messageEl.innerHTML : null,
      fillWidth: fillEl ? fillEl.style.width : null,
      shippingActive: shippingStep ? shippingStep.classList.contains('cgw-active') : false,
      giftActive: giftStep ? giftStep.classList.contains('cgw-active') : false,
    };
  }

  // Applies a previously captured state to whatever widget node is
  // currently in the DOM, instantly (no fade/transition), so a section
  // HTML swap doesn't cause a visible flash back to default values.
  function applyWidgetStateInstant(state) {
    if (!state) return;
    const widget = document.querySelector('.cgw-widget');
    if (!widget) return;
    const messageEl = widget.querySelector('.cgw-message');
    const fillEl = widget.querySelector('.cgw-progress-fill');
    const shippingStep = widget.querySelector('.cgw-step--shipping');
    const giftStep = widget.querySelector('.cgw-step--gift');

    if (messageEl && state.messageHtml != null) messageEl.innerHTML = state.messageHtml;
    if (fillEl && state.fillWidth != null) fillEl.style.width = state.fillWidth;
    if (shippingStep) shippingStep.classList.toggle('cgw-active', state.shippingActive);
    if (giftStep) giftStep.classList.toggle('cgw-active', state.giftActive);
  }

function applySectionUpdate(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    const preservedState = captureWidgetState();

    let doc = null;
    if (sections['cart-drawer']) {
      doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const newItems = doc.querySelector('#CartDrawer-CartItems');
      const currentItems = document.querySelector('#CartDrawer-CartItems');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }
      const newDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      }

      // ==== ADD THIS BLOCK HERE ====
      // .drawer__inner-empty lives OUTSIDE #CartDrawer-CartItems, as a
      // sibling inside .drawer__inner, so the innerHTML swap above never
      // touches it. Sync it in/out manually based on the new section.
      const newEmptyState = doc.querySelector('.drawer__inner-empty');
      const currentEmptyState = document.querySelector('.drawer__inner-empty');
      const drawerInner = document.querySelector('cart-drawer .drawer__inner');

      if (newEmptyState && !currentEmptyState && drawerInner) {
        drawerInner.insertBefore(newEmptyState.cloneNode(true), drawerInner.firstChild);
      } else if (newEmptyState && currentEmptyState) {
        currentEmptyState.replaceWith(newEmptyState.cloneNode(true));
      } else if (!newEmptyState && currentEmptyState) {
        currentEmptyState.remove();
      }
      // ==== END NEW BLOCK ====
    }

    // Update Customers Also Bought section
    if (doc) {
      const newRecommendations = doc.querySelector('.cart-drawer-recommendations');
      const currentRecommendations = document.querySelector('.cart-drawer-recommendations');

      if (newRecommendations && currentRecommendations) {
        currentRecommendations.replaceWith(newRecommendations);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else if (newRecommendations && !currentRecommendations) {
        const footer = document.querySelector('.drawer__footer');
        if (footer) footer.insertAdjacentElement('beforebegin', newRecommendations);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } else if (!newRecommendations && currentRecommendations) {
        currentRecommendations.remove();
      }
    }

    if (sections['cart-icon-bubble']) {
      const bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
      const currentBubbleWrapper = document.querySelector('#cart-icon-bubble');
      if (currentBubbleWrapper) currentBubbleWrapper.innerHTML = bubbleDoc.body.innerHTML;
    }

    applyWidgetStateInstant(preservedState);
}

  // Adds or removes the free gift line item to match current progress,
  // and asks Shopify to re-render the affected sections in the same
  // request so the drawer updates live (no page refresh needed).
  async function syncGift(cart, giftGoal, totalForGoal) {
    if (giftSyncInProgress) return cart;
    const giftLine = findGiftLine(cart);
    const qualifies = totalForGoal >= giftGoal;

    if (qualifies && !giftLine) {
      giftSyncInProgress = true;
      try {
        const addRes = await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        if (!addRes.ok) {
          console.warn('CGW: could not add free gift, check inventory/availability for variant', GIFT_VARIANT_ID);
        } else {
          const addData = await addRes.json();
          applySectionUpdate(addData.sections);
          showGiftPopup(); // fires only on a real, successful add of the gift line
        }
        const res = await originalFetch('/cart.js', { cache: 'no-store' });
        cart = await res.json();
      } catch (e) {
        // fail silently — widget will just retry on next cart update
      } finally {
        giftSyncInProgress = false;
      }
    } else if (!qualifies && giftLine) {
      giftSyncInProgress = true;
      try {
        const changeRes = await originalFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftLine.key,
            quantity: 0,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });
        if (changeRes.ok) {
          const changeData = await changeRes.json();
          applySectionUpdate(changeData.sections);
        }
        const res = await originalFetch('/cart.js', { cache: 'no-store' });
        cart = await res.json();
      } catch (e) {
        // fail silently
      } finally {
        giftSyncInProgress = false;
      }
    }
    return cart;
  }

  // Paints the message/fill/step states onto whatever .cgw-widget is
  // currently in the DOM. Kept separate from fetchAndRender so we can
  // call it immediately (fast) and again later once the gift sync
  // finishes (which involves an extra network round trip).
  //
  // giftPosition is the fixed left% where the gift icon marker sits
  // (e.g. 50 for dead-center). The fill bar is calculated in two
  // stages so it visually lines up with that marker instead of
  // assuming the gift icon is always at 100%:
  //   0 -> giftGoal        maps to  0%          -> giftPosition%
  //   giftGoal -> shippingGoal maps to giftPosition% -> 100%
  function renderWidget(total, shippingGoal, giftGoal, giftPosition) {
    const widget = document.querySelector('.cgw-widget');
    if (!widget) return;

    const fillEl = widget.querySelector('.cgw-progress-fill');
    const shippingStep = widget.querySelector('.cgw-step--shipping');
    const giftStep = widget.querySelector('.cgw-step--gift');

    let messageHtml;
    if (total < giftGoal) {
      const remaining = formatMoney(giftGoal - total);
      messageHtml = `You're just <span class="cgw-remaining">${remaining}</span> away from your FREE Gift.`;
    } else if (total < shippingGoal) {
      const remaining = formatMoney(shippingGoal - total);
      messageHtml = `You're just <span class="cgw-remaining">${remaining}</span> away from your FREE shipping.`;
    } else {
      messageHtml = ` Congratulations! You’ve unlocked FREE Gift and FREE Shipping!`;
    }
    setMessage(widget, messageHtml);

    let percent;
    if (total <= giftGoal) {
      percent = giftGoal > 0 ? (total / giftGoal) * giftPosition : 0;
    } else {
      const remainingRange = shippingGoal - giftGoal;
      const progressInRange = remainingRange > 0 ? (total - giftGoal) / remainingRange : 1;
      percent = giftPosition + progressInRange * (100 - giftPosition);
    }
    percent = Math.max(0, Math.min(100, percent));
    fillEl.style.width = percent + '%';

    shippingStep.classList.toggle('cgw-active', total >= shippingGoal);
    giftStep.classList.toggle('cgw-active', total >= giftGoal);
  }

  async function fetchAndRender() {
    const widget = document.querySelector('.cgw-widget');
    if (!widget) return;

    const shippingGoal = parseFloat(widget.dataset.shippingGoal);
    const giftGoal = parseFloat(widget.dataset.giftGoal);
    const giftPosition = parseFloat(widget.dataset.giftPosition) || 50;

    const myToken = ++requestToken;
    let cart;
    try {
      const res = await originalFetch('/cart.js', { cache: 'no-store' });
      cart = await res.json();
    } catch (e) {
      return;
    }
    if (myToken !== requestToken) return;

  const total = totalExcludingGift(cart);

// Update free shipping message immediately
if (window.updateFreeShippingMessage) {
  window.updateFreeShippingMessage(cart);
}

// Render immediately
renderWidget(total, shippingGoal, giftGoal, giftPosition);

    // 2) Sync the gift item in the background. This may take a moment
    // (extra API call + Shopify re-rendering the drawer HTML).
    const syncedCart = await syncGift(cart, giftGoal, total);
    if (myToken !== requestToken) return;

    const finalTotal = totalExcludingGift(syncedCart);

    // 3) Only re-render if the gift sync actually changed anything
    // (it usually won't change `total`, since the gift itself is
    // excluded from it — but the widget node may have been replaced
    // by applySectionUpdate, so we re-query and repaint the new one
    // to make sure it isn't left stuck on stale/default content).
    renderWidget(finalTotal, shippingGoal, giftGoal, giftPosition);

if (window.updateFreeShippingMessage) {
  window.updateFreeShippingMessage(syncedCart);
}
  }

  function updateGoalBar() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fetchAndRender, 120);
  }

  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function isCartRequest(input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    return CART_ENDPOINTS.some((ep) => url.indexOf(ep) !== -1);
  }

  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

    // Defense in depth: block any /cart/change.js request that targets
    // the gift line, even if it didn't originate from this script.
    if (url.indexOf('/cart/change') !== -1 && args[1] && args[1].body) {
      try {
        const body = JSON.parse(args[1].body);
        if (body.id) {
          return originalFetch('/cart.js', { cache: 'no-store' })
            .then((r) => r.json())
            .then((cart) => {
              const line = cart.items.find((i) => i.key === body.id);
              if (line && line.variant_id === GIFT_VARIANT_ID && giftSyncInProgress === false) {
                console.warn('CGW: blocked manual change to free gift line item');
                return new Response(JSON.stringify(cart), { status: 200 });
              }
              const promise = originalFetch.apply(this, args);
              promise.then(() => updateGoalBar()).catch(() => {});
              return promise;
            });
        }
      } catch (e) {
        // not JSON body, fall through to normal handling below
      }
    }

    const promise = originalFetch.apply(this, args);
    if (isCartRequest(args[0])) {
      promise.then(() => updateGoalBar()).catch(() => {});
    }
    return promise;
  };

  const originalXhrOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.addEventListener('loadend', () => {
      if (isCartRequest(url)) {
        updateGoalBar();
      }
    });
    return originalXhrOpen.call(this, method, url, ...rest);
  };

  document.addEventListener('cart:refresh', updateGoalBar);
  document.addEventListener('cart:updated', updateGoalBar);
  document.addEventListener('cart:build', updateGoalBar);

  document.addEventListener('DOMContentLoaded', fetchAndRender);
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    fetchAndRender();
  }
})();